import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate } from 'react-router';

import { useMutationRenewSubscription } from '@src/api/mutations';
import { useUserInfo } from '@src/api/queries';
import { HeaderLogo } from '@src/components/layouts/Header/HeaderLogo';
import { Button } from '@src/components/ui/Button/Button';
import { IS_DEVELOPMENT, NAVIGATION } from '@src/constants';
import { authLogoutUtils } from '@src/helpers/auth.helpers';
import { capitalizeFirstLetter } from '@src/helpers/string.helpers';

export const DashboardLayout = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const profile = useUserInfo();

  const renew = useMutationRenewSubscription();

  const onLogout = async () => {
    await authLogoutUtils();
    navigate(NAVIGATION.LOGIN, { replace: true });
  };

  const name = capitalizeFirstLetter(profile.data?.name || '');

  return (
    <div className="flex min-h-screen flex-col items-center bg-blue-2 font-assistant">
      <div className="flex w-full items-center justify-between gap-2.5 h-16 sm:h-18 px-5 sm:px-16 bg-white mb-7.5 sm:mb-10">
        <HeaderLogo clickableLogo logoProps={{ className: 'h-6!' }} />
        <div className="flex min-w-0 flex-1 gap-2.5 justify-end">
          <p className="hidden sm:block min-w-0 shrink truncate whitespace-nowrap">
            {t('global.text.welcome', { name })}
          </p>
          <button
            type="button"
            className="cursor-pointer shrink-0 whitespace-nowrap text-blue-1 font-bold underline underline-offset-2 hover:text-blue-9 duration-200"
            onClick={onLogout}
          >
            {t('button.logout')}
          </button>
        </div>
      </div>
      <div className="w-full px-4">
        <div className="w-full px-5 py-8 sm:p-12 rounded-xl bg-white max-w-140 mx-auto">
          <Outlet />
        </div>
      </div>
      <div className="w-full h-16 sm:h-18 mt-auto flex items-center justify-center text-sm">
        <p>{t('footer.copyright2', { year: dayjs().year() })}</p>
      </div>
      {profile?.data?.subscription?.is_canceled && IS_DEVELOPMENT && (
        <Button
          className="absolute right-1 bottom-1 max-w-max"
          onClick={() => renew.mutate()}
          isLoading={renew.isPending}
        >
          {t('profile.reactivate')}
        </Button>
      )}
    </div>
  );
};
